import { render } from "./TaskEmailView.vue?vue&type=template&id=24411ef6&scoped=true"
import script from "./TaskEmailView.vue?vue&type=script&lang=js"
export * from "./TaskEmailView.vue?vue&type=script&lang=js"

import "./TaskEmailView.vue?vue&type=style&index=0&id=24411ef6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24411ef6"]])

export default __exports__